import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import App from "./App";
import {
  AIDeploymentOptimization,
  MaritimeAutonomousNavigation,
  Registration3D,
  TacticalGameAgent,
} from "./project";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <HashRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route
          path="/MaritimeAutonomousNavigation"
          element={<MaritimeAutonomousNavigation />}
        />
        <Route path="/Registration3D" element={<Registration3D />} />
        <Route
          path="/AIDeploymentOptimization"
          element={<AIDeploymentOptimization />}
        />
        <Route path="/TacticalGameAgent" element={<TacticalGameAgent />} />
      </Routes>
    </HashRouter>
  </React.StrictMode>,
);
